module.exports = __webpack_public_path__ + "img/chevron--sort--down 1.c2af28ba.svg";